import { useParams } from 'react-router';
import { KeyStore } from '../engine/helpers/KeyStore';
const getDefaultGetStreamOptions = () => {
    return {
        broadcastTitle: 'Broadcast',
        broadcastStartsAt: Date.now(),
    };
};
export function getStreamPathname(streamId, options = getDefaultGetStreamOptions()) {
    const keyStore = KeyStore.getInstance();
    return (`/stream/${streamId}` +
        `?aesKey=${keyStore.getAesKey(streamId)}&publicKey=${keyStore.getPublicKey(streamId)}` +
        `&title=${encodeURIComponent(options.broadcastTitle ?? 'Broadcast')}` +
        `&startTime=${options.broadcastStartsAt ?? Date.now()}`);
}
export function getStreamUrl(streamId, options = getDefaultGetStreamOptions()) {
    const url = new URL(window.location.toString());
    url.hash = getStreamPathname(streamId, options);
    return url.toString();
}
export function useRequiredParam(key) {
    const value = useParams()[key];
    if (!value) {
        throw new Error(`Invalid context (missing "${key}" param`);
    }
    return value;
}
export function generateStreamId() {
    return `stream-${Math.random().toString(36).substring(2)}`;
}
